import React from 'react';
import ReactDOM from 'react-dom';

import './index.css';
import AppSetup from './appSetup';
import * as serviceWorker from './serviceWorker';
import { Auth0Provider } from './react-auth0-spa';
import history from './utils/history';
import { AUTH0_CLIENT_ID, AUTH0_DOMAIN, AUTH0_FOOTHOLD_API_AUDIENCE } from './config';

const onRedirectCallback = (appState:any) => {
  history.push(
    appState && appState.targetUrl
      ? appState.targetUrl
      : window.location.pathname,
  );
};

const config = {
  clientId: AUTH0_CLIENT_ID,
  domain: AUTH0_DOMAIN,
};

ReactDOM.render(
  <Auth0Provider
    domain={config.domain}
    client_id={config.clientId}
    redirect_uri={window.location.origin}
    onRedirectCallback={onRedirectCallback}
    audience={AUTH0_FOOTHOLD_API_AUDIENCE}
    scope="read:current_user offline_access"
    useRefreshTokens
  >
    <AppSetup />
  </Auth0Provider>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
